import { render, staticRenderFns } from "./multi-account-cbr.vue?vue&type=template&id=61a7a1bd"
import script from "./multi-account-cbr.vue?vue&type=script&lang=js"
export * from "./multi-account-cbr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports